export default __webpack_public_path__ + "images/Escola_TESTE_Ano_X_Aluno_FULANO.pdf";